var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.progress)?_c('v-progress-linear',{staticStyle:{"z-index":"800"},attrs:{"fixed":"","top":"","color":"pink"},model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }